import React, { useMemo, useRef, useState, useEffect } from "react";
import Button from "../../components/form/Button";
import FullScreenLoader from "../../components/common/FullScreenLoader";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import { setPostLoginRedirect } from "../../helpers/keycloakAuth";
// Recruiter flow (temporarily disabled)
// import { useQuery } from "@tanstack/react-query";
// import FlexibleSelect from "../../components/form/select/FlexibleSelect";
// import { organizationList } from "../../services/taxonomyService";
// import { toast } from "react-toastify";
// import { userGetOrganization } from "../../services/userService";

const Login = () => {
  const auth = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const hasAutoRedirected = useRef(false);
  // Recruiter flow (temporarily disabled)
  // const [step, setStep] = useState("action");
  // const [action, setAction] = useState("");
  // const [recruiterIdentifier, setRecruiterIdentifier] = useState("");
  // const [lookupState, setLookupState] = useState({
  //   status: "idle",
  //   organizationId: "",
  //   organizationName: "",
  // });
  // const [organizationId, setOrganizationId] = useState("");

  const redirectTo = location?.state?.from || "/";
  const isBusy = auth.isLoading || auth.activeNavigator === "signinRedirect";

  useEffect(() => {
    const isAuthPath =
      location.pathname === "/signin" || location.pathname === "/login";
    if (!isAuthPath) {
      return;
    }
    if (auth.isLoading) {
      return;
    }
    if (auth.isAuthenticated) {
      navigate(redirectTo, { replace: true });
      return;
    }
    if (hasAutoRedirected.current || isBusy) {
      return;
    }
    hasAutoRedirected.current = true;
    setPostLoginRedirect(redirectTo);
    auth.signinRedirect({ state: { internalRole: "user" } });
  }, [
    location.pathname,
    auth.isLoading,
    auth.isAuthenticated,
    isBusy,
    redirectTo,
    auth,
    navigate,
  ]);

  const handleLogin = (role) => {
    setPostLoginRedirect(redirectTo);
    auth.signinRedirect({ state: { internalRole: role } });
  };

  // Recruiter flow (temporarily disabled)
  // const { data: organizationData, isLoading: organizationLoading } = useQuery({
  //   queryKey: ["organization", "public-list"],
  //   queryFn: async () => {
  //     const res = await organizationList({ limit: 10000 });
  //     return res?.docs || res?.data || res;
  //   },
  //   enabled: step === "recruiter-register",
  // });

  // Recruiter flow (temporarily disabled)
  // const organizationOptions = useMemo(() => {
  //   const list = organizationData?.data || organizationData || [];
  //   return Array.isArray(list)
  //     ? list.map((item) => ({
  //         value: item?._id,
  //         name:
  //           item?.content?.en?.title || item?.name || item?.title || "Unnamed",
  //       }))
  //     : [];
  // }, [organizationData]);

  // Recruiter flow (temporarily disabled)
  // const handleRecruiterContinue = () => {
  //   if (!organizationId) {
  //     toast.error("Please select an organization");
  //     return;
  //   }
  //   setPostLoginRedirect(redirectTo);
  //   auth.signinRedirect({
  //     state: { internalRole: "recruiter", organizationId },
  //   });
  // };

  // const handleRecruiterLookup = async () => {
  //   const identifier = recruiterIdentifier.trim();
  //   if (!identifier) {
  //     toast.error("Enter email or username");
  //     return;
  //   }
  //   setLookupState({ status: "loading", organizationId: "", organizationName: "" });

  //   const isEmail = identifier.includes("@");
  //   try {
  //     const res = await userGetOrganization(
  //       isEmail ? { email: identifier } : { username: identifier }
  //     );
  //     const payload = res?.data || res || {};
  //     const org =
  //       payload?.organization ||
  //       payload?.org ||
  //       payload?.data?.organization ||
  //       (payload?._id ? payload : null) ||
  //       (payload?.data?._id ? payload.data : null);
  //     const orgId =
  //       org?._id ||
  //       payload?.organizationId ||
  //       payload?.orgId ||
  //       payload?.data?.organizationId ||
  //       "";
  //     const orgName =
  //       org?.content?.en?.title ||
  //       org?.name ||
  //       payload?.organizationName ||
  //       payload?.orgName ||
  //       "";

  //     if (orgId) {
  //       setLookupState({
  //         status: "found",
  //         organizationId: orgId,
  //         organizationName: orgName,
  //       });
  //       return;
  //     }

  //     setLookupState({
  //       status: "not_found",
  //       organizationId: "",
  //       organizationName: "",
  //     });
  //   } catch (error) {
  //     setLookupState({ status: "error", organizationId: "", organizationName: "" });
  //     toast.error("Unable to fetch organization");
  //   }
  // };

  // const handleRecruiterContinueKnownOrg = () => {
  //   if (!lookupState.organizationId) {
  //     toast.error("Organization not found");
  //     return;
  //   }
  //   setPostLoginRedirect(redirectTo);
  //   auth.signinRedirect({
  //     state: {
  //       internalRole: "recruiter",
  //       organizationId: lookupState.organizationId,
  //     },
  //   });
  // };

  if (location.pathname === "/signin" || location.pathname === "/login") {
    return <FullScreenLoader />;
  }

  return (
    <section className="relative flex items-center w-full min-h-screen py-16 sm:py-24 bg-slate-50 overflow-hidden">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-32 -left-24 h-96 w-96 rounded-full bg-blue-200/60 blur-3xl" />
        <div className="absolute -bottom-40 -right-20 h-[28rem] w-[28rem] rounded-full bg-sky-300/50 blur-3xl" />
        <div className="absolute inset-0 opacity-40 bg-[radial-gradient(circle_at_1px_1px,rgba(59,130,246,0.08)_1px,transparent_0)] [background-size:22px_22px]" />
      </div>

      <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4 relative">
        <div className="flex justify-center">
          <div className="relative w-full max-w-lg overflow-hidden rounded-3xl border border-white/70 bg-gradient-to-br from-white via-slate-50 to-blue-100/70 shadow-[0_30px_70px_-35px_rgba(15,23,42,0.55)]">
            <div className="absolute left-0 top-0 h-full w-1.5 bg-gradient-to-b from-blue-400 via-sky-400 to-blue-600" />
            <div className="px-8 py-10 md:px-12 md:py-12">
              <div className="flex items-center justify-center">
                <span className="inline-flex items-center rounded-full bg-blue-100/70 px-3 py-1 text-[11px] font-semibold tracking-wide text-blue-700">
                  Secure SSO
                </span>
              </div>
              <div className="mt-4 text-center space-y-3">
                <h1 className="text-3xl md:text-4xl font-semibold text-slate-900">
                  Sign In
                </h1>
                <p className="text-sm text-slate-600">
                  Choose how you want to continue.
                </p>
              </div>

              <div className="mt-8 space-y-4 text-center">
                {/* Recruiter flow (temporarily disabled) */}
                {true ? (
                  <>
                    <Button
                      buttonLabel={isBusy ? "Redirecting..." : "Continue as User"}
                      buttonClasses="!w-full !h-12 !rounded-full !bg-gradient-to-r !from-blue-600 !to-blue-500 hover:!from-blue-700 hover:!to-blue-600 !shadow-lg !shadow-blue-500/30"
                      buttonFunction={() => handleLogin("user")}
                      isDisable={isBusy}
                      loading={isBusy}
                    />
                  </>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
      {isBusy && <FullScreenLoader />}
    </section>
  );
};

export default Login;
